import type { Router } from 'vue-router'

/**
 * @description 处理子账号点击头部导航菜单的跳转
 * @param {string} path
 * @param {Router} router
 */
const subAccounJumpHandler = (path: string, router: Router) => {
  router.push({ path })
}

const accountJumpHandler = (path: string, router: Router) => {
  router.push({ path })
  // switch (true) {
  //   case examineAllState === CertificationStatus.Auditing:
  //     router.push({ path: '/controlCenter/certificationReview' })
  //     break

  //   case [CertificationStatus.NotCertified, CertificationStatus.AuditFailed].includes(examineAllState):
  //     router.push({ path: '/controlCenter/certification' })
  //     break
  //   default:
  //     router.push({ path })
  //     break
  // }
}

export { subAccounJumpHandler, accountJumpHandler }
